import React from 'react';
import Page from './page';

export const LoginDialog = ({open, handleClose}) => {
  return (
      <Page {...{open, handleClose}}/>
  );
}

export default LoginDialog;